$(document).ready(function(){
    handleDisclosureClicks();
    handleMultislideCarrousels();
    handleMultislideCarrousel(6,'.carousel-item-tile');
    handleSplitScrollSearch();
    validateNinjaFormsLetterOnlyInput();
})

//Define icontains as case-insensitive search ignoring diacritics
$.expr[':'].icontains = function(a, i, m) {
    const needle = jQuery(a).text().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    const haystack = m[3].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()
    return needle.indexOf(haystack) >= 0;
};

function handleDisclosureClicks(){
    //Check that the block is present
    if(!!document.getElementById('disclousures-collapse-body')){
        const disclosuresCollapse = new bootstrap.Collapse('#disclousures-collapse-body',{
            toggle: false
        });
        $("a[href^='#disclosure-']").on('click', function(a,b,c) {
            var collapseElement = $('#disclousures-collapse-body');
            if(!collapseElement.hasClass( "show" )){
                a.preventDefault();
                disclosuresCollapse.show();
                collapseElement.on('shown.bs.collapse',function (){
                    document.getElementById(a.target.hash.replace("#","")).scrollIntoView(true);
                });
            }
        });
    }
}

function handleMultislideCarrousels(){
    let carousels = document.querySelectorAll('[id^=\'articleCarousel-\']');
    carousels.forEach(carousel => {
        handleMultislideCarrousel(3,'.carousel-item-article-'+carousel.getAttribute('data-carousel-id'));
    });
}

function handleMultislideCarrousel(slides,selector){
    let items = document.querySelectorAll(selector);
    items.forEach((el) => {
        const minPerSlide = slides;
        let next = el.nextElementSibling
        for (var i=1; i<minPerSlide; i++) {
            if (!next) {
                // wrap carousel by using first child
                next = items[0]
            }
            let cloneChild = next.cloneNode(true)
            el.appendChild(cloneChild.children[0])
            next = next.nextElementSibling
        }
    })
}

function validateNinjaFormsLetterOnlyInput() {
    if($('.schedule-meeting-block').length) {
        var contactFormValidationController = Marionette.Object.extend( {
            initialize: function() {
                //Handle validations
                this.listenTo( Backbone.Radio.channel( 'submit' ), 'validate:field', this.validateRequired );
                this.listenTo( Backbone.Radio.channel( 'fields' ), 'change:modelValue', this.validateRequired );
            },

            validateRequired: function ( model ){
                //Check for fields that allow letters only
                if(model && model.attributes.key.toLowerCase().includes('-letters-only')){
                    const lettersOnlyRegex = /\p{N}|\p{P}/gu;
                    const notLettersOnly = lettersOnlyRegex.test(model.attributes.value);
                    if(notLettersOnly){
                        Backbone.Radio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'letters-only-error', 'Only letters are allowed.' );
                    }else{
                        Backbone.Radio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'letters-only-error');
                    }
                //validate international phone numbers
                }else if(model && model.attributes.key.toLowerCase().includes('phone-number-international')){
                    let number = model.attributes.value;
                    var numbersOnly = /^\d+$/;
                    var isNumbersOnly = numbersOnly.test(number);
                    var phoneToValidate;
                    if(isNumbersOnly){
                        let countryCode = $('.phone-number-country-code').val();
                        if(countryCode){
                            var parenthesisExtract = /\(([^)]+)\)/;
                            var matches = parenthesisExtract.exec(countryCode);
                            if(matches) countryCode = matches[1];
                        }
                        if(countryCode) number = countryCode +''+ number;
                        phoneToValidate = new libphonenumber.parsePhoneNumber(number,'US');
                    }
                    if(!isNumbersOnly || !phoneToValidate.isPossible()){
                        Backbone.Radio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'phone-number-invalid', 'Phone number is invalid.' );
                    }else{
                        Backbone.Radio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'phone-number-invalid');
                    }
                //This is in place just so a change to the country code drop down triggers a revalidation of the phone number
                }else if(model && model.attributes.key.toLowerCase().includes('phone-number-country-code')){
                    let phoneInput = $('input[name="phone"]');
                    const currentNumber = phoneInput.val();
                    phoneInput.val('').trigger('change');
                    phoneInput.val(currentNumber).trigger('change');
                }
            },
        });

        new contactFormValidationController();
    }
}

function handleSplitScrollSearch() {
    if($('.split-scroll-block').length && $('#split-scroll-search').length){
        $('#split-scroll-search').on('input', function(e) {
            var rows = $(".split-scroll-content").find("tr").hide();
            var searchWords = this.value.split(" ");
            $.each(searchWords, function(i, v) {
                rows.filter(":icontains('" + v + "')").show();
            });
            var tabPanes = $(".split-scroll-content").find(".tab-pane").show();
            $.each(tabPanes, function (index,tabPane){
                if(!$(this).find("tr:visible").length) $(this).hide();
            });
        });
    }
}
